import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import css from './SectionStats.module.css';

const SectionStats = props => {
  const { stats } = props;

  // Default stats if none provided
  const defaultStats = [
    { number: '130+', label: 'Transactions' },
    { number: '140+', label: 'Certified Trainers' },
    { number: '5.0', label: 'Average Rating' },
    { number: '20+', label: 'Cities Available' },
  ];

  const displayStats = stats || defaultStats;

  return (
    <section className={css.root}>
      <div className={css.container}>
        {displayStats.map((stat, index) => (
          <div key={index} className={css.statItem}>
            <div className={css.statNumber}>{stat.number}</div>
            <div className={css.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

SectionStats.defaultProps = {
  stats: null,
};

SectionStats.propTypes = {
  stats: arrayOf(
    shape({
      number: string.isRequired,
      label: string.isRequired,
    })
  ),
};

export default SectionStats;